import { render, staticRenderFns } from "./IconLinkItem.vue?vue&type=template&id=66baf655"
import script from "./IconLinkItem.vue?vue&type=script&lang=ts"
export * from "./IconLinkItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66baf655')) {
      api.createRecord('66baf655', component.options)
    } else {
      api.reload('66baf655', component.options)
    }
    module.hot.accept("./IconLinkItem.vue?vue&type=template&id=66baf655", function () {
      api.rerender('66baf655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/sidebaritems/IconLinkItem.vue"
export default component.exports